import React from 'react';
import { ConfigProvider } from 'antd';
import { useTheme } from 'infrastructure/providers/theme';

import { lightTheme } from './themes/light';
import { darkTheme } from './themes/dark';

interface IAntThemeProviderProps {
  children: React.ReactNode;
}

const AntThemeProvider: React.FC<IAntThemeProviderProps> = (props) => {
  const { theme } = useTheme();
  const { children } = props;

  const themeSettings = theme === 'dark' ? darkTheme : lightTheme;

  return (
    <ConfigProvider theme={themeSettings} wave={{ disabled: true }}>
      {children}
    </ConfigProvider>
  );
};

export default AntThemeProvider;
